export default "__VITE_ASSET__ZvGCPnYQ__"